// @flow
import * as React from 'react';

import OptionsSelector from 'components/OptionsSelector';

type Props = {
  optionLookup: { [id: string]: string },
  selectedOptions: Array<string>,
  onChange: (newSelectedOptions: Array<string>) => void,
};

class EditOptions extends React.Component<Props> {
  render() {
    const { optionLookup, selectedOptions, onChange } = this.props;

    const initialSelections = Object.keys(optionLookup).reduce(
      (acc, id) => ({
        ...acc,
        [id]: selectedOptions.includes(id),
      }),
      {}
    );

    return (
      <div>
        <OptionsSelector
          label=""
          options={optionLookup}
          onOptionsSelected={onChange}
          initialSelections={initialSelections}
        />
      </div>
    );
  }
}

export default EditOptions;



// WEBPACK FOOTER //
// ./src/components/EditOptions/EditOptions.js